import { useState, useEffect } from "react";

export default function useShowOnScroll(pageYOffset) {
  const [isShown, setIsShown] = useState(false);

  useEffect(() => {
    // only execute all the code below in client side
    if (typeof window !== "undefined") {
      // Handler to call on window resize
      const onScroll = () => {
        if (window.scrollY <= pageYOffset) {
          setIsShown(false);
        } else {
          setIsShown(true);
        }
      };

      // Add event listener
      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", onScroll);

      // Call handler right away so state gets updated with initial window size
      onScroll();

      // Remove event listener on cleanup
      return () => {
        window.removeEventListener("scroll", onScroll, { passive: true });
        window.removeEventListener("resize", onScroll);
      };
    }
  }, [pageYOffset]); // Empty array ensures that effect is only run on mount
  return isShown;
}
